// 预警提醒
import { getAlarmReadFlag, getLoginWarnigTip } from '@/api/AlarmReminder'

const state = {
  alarmInfo: [],
  unProcessAlarmDot: false //工单预警未读标识
}
const mutations = {
  SET_ALARM_INFO: (state, data) => {
    state.alarmInfo = data
  },
  SET_UNPROCESS_ALARM_NUM(state, num) {
    state.unProcessAlarmDot = num
  }
}
const actions = {
  getUnProcessAlarmReadFlag({ commit }) {
    getAlarmReadFlag().then(res => {
      // 0-未读，1-已读
      commit('SET_UNPROCESS_ALARM_NUM', !res)
    })
  },
  getLoginAlarmInfo({ commit }) {
    getLoginWarnigTip().then(res => {
      commit('SET_ALARM_INFO', res || [])
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
